Spruce.store(
  "watchlist",
  {
    items: [],
    total() {
      return this.items.length;
    },
    has(identifier) {
      return this.items.some((i) => i.identifier === identifier);
    },
    add(item) {
      this.items.push(item);
    },
    remove(identifier) {
      this.items = this.items.filter((i) => i.identifier !== identifier);
    },
  },
  true
);
